
































import Vue from 'vue'
import api from '@/api'
import { SignUp } from '../types'

export default Vue.extend({
  name: 'AdminSignupList',

  data: () => ({
    signups: [] as Array<SignUp>,
  }),

  methods: {
    prettyDate(date: string): string {
      const d = new Date(date)
      return `${d.getMonth() + 1}/${d.getDate()}/${d.getFullYear()} ${d.getHours()}:${d.getMinutes()}`
    },
  },

  async mounted() {
    this.signups = await api.getSignups()
  },
})
